import styled, { keyframes } from "styled-components";
import Tooltip from "../../../components/tooltip";
import { Button } from "ratel-ui";

export const Container = styled.div`
  .modal-resolution-simulation {
    &-card {
      position: relative;
      width: 632px;
      max-width: calc(100vw - 32px);
      border-radius: 16px;
      overflow: hidden;
      box-shadow: 0px 2px 1.5px rgba(0, 0, 0, 0.1);
      background: #fff;
    }

    &-header {
      padding: 0;
      align-items: flex-start;
      justify-content: space-between;
      text-align: left;
      background-color: #0E8A3E;
    }

    &-title {
      display: block;
      font-family: "Nunito", sans-serif;
      font-size: 24px;
      font-weight: 700;
      text-align: left;
      line-height: 1;
      color: #fff;
    }

    &-subtitle {
      display: inline-block;
      width: 100%;
      font-size: 1rem;
      text-align: left;
      color: #fff;
    }

    &-close {
      display: flex;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background-color: rgba(0, 0, 0, 0.15);
    }

    &-icon {
      margin: auto;
      fill: #fff;
    }

    &-body {
      position: relative;
      width: 100%;
      padding: 24px 16px 16px;
      background-color: #fff;
      overflow: auto;
      max-height: 60vh;
      min-height: 120px;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    &-text {
      width: 100%;
      border-radius: 8px;
      background-color: ${(props) => props.theme.colors.transparent};
      overflow: hidden;

      strong {
        color: #121212;
        font-weight: 700;
      }

      &-actions {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 16px 16px;
      }
    }

    &-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 64px;
      border-top: 1px solid ${(props) => props.theme.colors.font7};
      background: ${(props) => props.theme.colors.transparent};

      &-button {
        display: flex;
        flex: 0 0 32px;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        margin-right: 16px;
        margin-left: 16px;
        border-radius: 50%;
        background: ${(props) => props.theme.colors.bg1};
        transition: 0.15s all ease;
        cursor: pointer;

        svg {
          fill: ${(props) => props.theme.colors.clear};
        }

        &:hover {
          opacity: 0.8;
        }

        &.disabled {
          cursor: default;
          background: ${(props) => props.theme.colors.font7};
        }
      }
    }
  }
`;

export const Content = styled.div``;

export const ResolutionContent = styled.div`
  transition: opacity 0.15s ease;
  opacity: ${(props) => (props.loading ? 0 : 1)};
`;

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  z-index: 5;
`;

export const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #e0e0e0;
  border-top-color: #0e8a3e;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

export const QuestionResolution = styled.div`
  :not(:first-child) {
    margin: 20px 0;
  }
`;

export const ReportIcon = styled.div`
  color: ${(props) => props.theme.colors.font6};
  position: relative;
  font-size: 14px;

  svg {
    fill: ${(props) => props.theme.colors.font6};
  }
`;

export const Report = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  cursor: pointer;

  textarea {
    margin-top: 8px;
    height: 56px;
    width: 100%;
    border-radius: 8px;
    padding: 8px;
    outline: none;
  }

  svg {
    margin: 12px 8px 0 0;
    fill: ${(props) => props.theme.colors.font6};
    cursor: pointer;
  }

  &.active {
    svg {
      fill: ${(props) => props.theme.colors.live};
    }
  }
`;

export const ReportTooltip = styled(Tooltip)`
  position: absolute;
  top: -150px;
  padding: 16px;
  text-align: right;
  z-index: 15;

  span {
    display: flex;
    width: 100%;
    padding-left: 16px;
    font-size: 0.875rem;
    color: rgba(255, 255, 255, 0.7);
    text-align: left;
  }

  button {
    right: 16px;
  }

  &:after {
    content: " ";
    position: absolute;
    top: 154px;
    left: 50px;
    width: 0;
    height: 0;
    margin-left: -35px;
    transform: rotate(-180deg);
  }
`;

export const Header = styled.header`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 16px;
  height: 64px;
  text-align: left;
  background-color: #0E8A3E;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
`;

export const Title = styled.span`
  display: block;
  font-family: "Nunito", sans-serif;
  font-size: 24px;
  font-weight: 700;
  text-align: left;
  line-height: 1;
  color: #fff;
`;

export const QuestionResolutionContent = styled.div`
  font-family: "Nunito", sans-serif;
  font-size: 16px;
  line-height: 1.4;
  color: #000;

  p {
    margin: 0 0 12px;
  }

  img {
    max-width: 100%;
    height: auto;
  }
`;

export const ButtonRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  border-top: 1px solid rgba(10, 10, 10, 0.1);
`;

export const NewButton = styled(Button)`
  height: 32px;
  min-height: 32px;
  width: 132px;
  border-radius: 16px;
  border: 1px solid #1B229F;
  color: #1B229F;
  background: transparent;
  font-family: "Nunito", sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;

  &:hover {
    border: 1px solid #1B229F;
    background: #1B229F;
    color: #fff;
  }

  &:focus {
    border: 1px solid #1B229F;
    background: #1B229F;
    color: #fff;
  }
`;